import styled from 'styled-components';
import {
    SURFACE_BASE,
    TERTIARY_BACKGROUND,
} from '@amzn/ring-common-style-library/lib/colors';

const IconContainer = styled.div<{ isOpen: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;

    width: 48px;
    height: 48px;
    flex-shrink: 0;
    padding: 12px;

    background: ${SURFACE_BASE};
    cursor: pointer;

    border-radius: 50%;
    border: 1px solid ${TERTIARY_BACKGROUND};
    box-shadow: 0px 8px 12px 0px var(--shadow-base, rgba(0, 0, 0, 0.15));

    /* Hover animation */
    transition: transform 0.3s ease, box-shadow 0.3s ease;

    &:hover {
        transform: scale(1.1);
        box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
    }
`;

const IconFlipper = styled.div<{ isOpen: boolean }>`
    position: relative;
    width: 24px;
    height: 24px;
    transform-style: preserve-3d;
    transition: transform 0.6s;
    transform: rotateY(${({ isOpen }) => (isOpen ? 180 : 0)}deg);
`;

const IconFace = styled.div`
    position: absolute;
    width: 24px;
    height: 24px;
    backface-visibility: hidden;
    top: 0;
    left: 0;

    &.front {
        /* Front face (ChatIcon) */
        transform: rotateY(0deg);
    }

    &.back {
        /* Back face (CloseIcon) */
        transform: rotateY(180deg);
    }
`;

export default {
    IconContainer,
    IconFlipper,
    IconFace,
};
